<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">App Development</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>App Development</li>
            </ul>
        </div>
    </div>
</div>

<div class="about-area position-relative overflow-hidden space mt-auto mt-md-5" id="about-sec">
    <div class="container">
        <div class="row">
            <div class="col-xl-6">
                <div class="img-box15 d-flex justify-content-center">
                    <div class="img1 d-none d-md-block">
                        <img src="assets/img/normal/about_15_1.jpg" alt="About">
                        <img src="assets/img/normal/about_15_2.jpg" alt="About">
                    </div>
                    <div class="img2">
                        <img src="assets/img/normal/about_15_3.jpg" alt="About">
                    </div>
                </div>
            </div>
            <div class="col-xl-6">
                <div class="about-15-title-box ps-xl-3 ms-xl-5">
                    <div class="title-area mb-20">
                        <span class="sub-title style1 text-anime-style-2">About Us</span>
                        <h2 class="sec-title mb-25 text-anime-style-3">Cloud Solutions for Every Business: Simplify,
                            Scale, Succeed</h2>
                    </div>
                    <p class="sec-text mb-30 me-xl-3 wow fadeInUp" data-wow-delay=".3s">Cloud computing solutions
                        provide businesses with the ability to store, manage, and process data and applications over the
                        internet instead of relying on local servers or personal devices. These solutions offer
                        scalability, flexibility, and cost-efficiency, enabling organizations.</p>
                    <div class="about-feature-wrap">
                        <div class="about-feature-list">
                            <ul>
                                <li class="wow fadeInUp" data-wow-delay=".4s">
                                    <span class="about-feature-icon"><img src="assets/img/icon/checkmark.svg"
                                            alt=""></span>
                                    Data Storage and Backup
                                </li>
                                <li class="wow fadeInUp" data-wow-delay=".5s">
                                    <span class="about-feature-icon"><img src="assets/img/icon/checkmark.svg"
                                            alt=""></span>
                                    Data Backup and Disaster Recovery
                                </li>
                                <li class="wow fadeInUp" data-wow-delay=".5s">
                                    <span class="about-feature-icon"><img src="assets/img/icon/checkmark.svg"
                                            alt=""></span>
                                    Hybrid and Multi-Cloud Solutions
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="mt-35 wow fadeInUp" data-wow-delay=".6s">
                        <a routerLink="/services" class="th-btn th-icon">Discover More <i
                                class="fa-light fa-arrow-right-long"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="shape-mockup jump z-index-1 d-none d-xl-block" data-bottom="12%" data-right="5.5%">
        <img src="assets/img/shape/shape_2_1.png" alt="shape">
    </div>
</div>

<!--======== Footer Section ========-->
<app-footer></app-footer>